/* global fetch */

class CoreMediaHelper {
    init () {
        let cmInfoDOM = document.getElementById('cm-preview-data');
        if (!cmInfoDOM) {
            return;
        }
        let cmInfo = JSON.parse(cmInfoDOM.textContent);
        if (cmInfo.preview) {
            let banner = document.getElementById('cm-preview-banner');
            banner.style.display = 'block';
            let publicationStatusToggle = banner.querySelector('.js-cmsf-toggle-publication-status');
            publicationStatusToggle.addEventListener('click', () => {
                document.querySelector('.cm-slot-main').classList.toggle('cmsf-highlight-preview');
                publicationStatusToggle.classList.toggle('csmf-on');
            });
            banner.querySelector('.js-cmsf-toggle-preview-status').addEventListener('click', () => {
                let serviceURL = banner.dataset.disablecmpreview;
                fetch(serviceURL).then(() => { location.reload(); });
            });
            banner.querySelector('.js-cmsf-list-unpublished').addEventListener('click', () => {
                let unpublishedDOM = Array.from(document.querySelectorAll('[data-publication-status="unpublished"]'));
                let info = unpublishedDOM.map((element) => {
                    let jsoninfo = JSON.parse(element.dataset.verboseInfo);
                    return `<li>${jsoninfo.contentName} (coremedia id: ${jsoninfo.contentId})</li>`;
                }).join('');
                let container = document.querySelector('#js-unpublished-content');
                container.innerHTML = `<ul>${info}</ul>`;
                document.getElementById('js-unpublished-content-dialog').showModal();
            });
            banner.querySelector('.js-cmsf-close').addEventListener('click', () => {
                banner.style.display = 'none';
            });
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    let cm = new CoreMediaHelper();
    cm.init();
});
